export default {"src":"/_next/static/media/two-highlighters.d1d588ea.gif","height":700,"width":700};